export default function () {
  const items = document.querySelectorAll(".navigation .nav-link");
  items.forEach(i => {
    if (i.classList.contains("active")) i.classList.remove("active");

    if (document.location.pathname === i.pathname
        && !i.hash) {
      i.classList.add("active");
    }
  });
}